import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const savedUser = localStorage.getItem('admin_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const res = await api.post('/blog/auth/login', { email, password });
      const data = res.data;

      // Laravel AuthController returns: { success, message, data: { user, token } }
      const success = data?.success === true;
      const payload = data?.data || {};
      const user = payload.user;
      const token = payload.token || null;

      if (success && user) {
        if (token) {
          localStorage.setItem('admin_token', token);
        }
        localStorage.setItem('admin_user', JSON.stringify(user));
        setUser(user);
        return { success: true };
      }

      return { success: false, message: data?.message || 'Login failed' };
    } catch (err) {
      // 422 validation / invalid credentials
      const apiData = err.response?.data;
      const validationMsg =
        (apiData?.errors && Object.values(apiData.errors).flat()[0]) ||
        apiData?.message;
      return { success: false, message: validationMsg || 'Invalid credentials' };
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_user');
    localStorage.removeItem('admin_token');
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
